import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop - Composant qui fait défiler la page vers le haut
 * lors de chaque changement de route (navigation)
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll vers le haut avec un comportement fluide
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 'instant' pour un scroll immédiat, 'smooth' pour animation
    });
  }, [pathname]);

  return null; // Ce composant ne rend rien visuellement
};

export default ScrollToTop;
